import { Module } from "shared/types/shared";

export const paths: Partial<Record<Module, string>> = {
  adLoad: "/ad-library/load",
};
